import * as Yup from "yup";

const createValidationSchema = fieldName => {
  return Yup.string().required(`${fieldName} is required`);
};

const emailValidation = Yup.string().email("Invalid Email").required("Email is required");

const loginSchema = Yup.object().shape({
  email: emailValidation,
  password: createValidationSchema("Password"),
  rememberMe: Yup.boolean(),
});

const resetPasswordSchema = Yup.object().shape({
  isCodeSent: Yup.boolean().default(false),
  email: emailValidation,
  // conditionally required if isCodeSent is true
  newPassword: Yup.string().when("isCodeSent", {
    is: true,
    then: () => createValidationSchema("New Password"),
  }),
  confirmationCode: Yup.string().when("isCodeSent", {
    is: true,
    then: () => createValidationSchema("Confirmation Code"),
  }),
});

const updatePasswordSchema = Yup.object().shape({
  password: createValidationSchema("Password"),
});


const propertyDetailSchema = Yup.object().shape({
  name: createValidationSchema("Property Name"),
  address: Yup.string(),
  city: createValidationSchema("City"),
  state: createValidationSchema("State"),
  zipCode: Yup.string(),
  type: createValidationSchema("Property Type"),
  projectStatus: createValidationSchema("Project Status"),
  squareFootage: Yup.string(),
  clientName: Yup.string(),
  clientEmail: Yup.string().email("Invalid Email"),
});

export { loginSchema, propertyDetailSchema, resetPasswordSchema, updatePasswordSchema };
